import { z } from 'zod';
/** Standard Stripe fees: 2.9% + $0.30. Override via env for non-US rates. */
export const STRIPE_FEE_PERCENT = 0.029;
export const STRIPE_FEE_FIXED_CENTS = 30;
/**
 * Default EVI platform cut (%): the value a new Location is stamped with
 * and the fallback when neither Location nor Tenant sets one. Tier 2
 * pricing (Warren, 2026-09-26): 15% on residential, building-resident
 * and Owner Program charging; commercial 15% of net.
 *
 * The DEFAULT is not the FLOOR. A new session's pinned rate is
 * max(resolved, PLATFORM_FEE_FLOOR_BPS) whatever a Location stores;
 * the two constants are separate so a grandfathered host could sit
 * above one and below the other without either lying.
 */
export const DEFAULT_PLATFORM_PERCENT = 15;
/**
 * The platform fee floor written into every NEW session's pin
 * (`Session.effective_admin_fee_bps`) at start. A stored revenue_split
 * or admin_fee_bps below it cannot lower EVI's share on a new session.
 */
export const PLATFORM_FEE_FLOOR_BPS = 1500;
/**
 * The floor settlement applies to a session's pin - and the rate for a
 * session that has NO pin (pre-pin legacy). Sessions pinned before
 * Tier 2 carry a pin of 1000 and must settle at the price they started
 * under, so this stays at the old floor. NEVER raise it: raising it
 * reprices every in-flight legacy session and every recovery.
 */
export const LEGACY_PLATFORM_FEE_FLOOR_BPS = 1000;
export const RevenueSummarySchema = z.object({
    total_revenue_cents: z.number().int().nonnegative(),
    stripe_fees_cents: z.number().int().nonnegative(),
    electricity_cost_cents: z.number().int().nonnegative(),
    platform_fees_cents: z.number().int().nonnegative(),
    owner_payouts_cents: z.number().int().nonnegative(),
    session_count: z.number().int().nonnegative(),
    total_energy_kwh: z.number().nonnegative(),
    currency: z.string().length(3),
    /** Date range covered by this summary */
    from: z.coerce.date(),
    to: z.coerce.date(),
});
export const TransactionStatusSchema = z.enum([
    'paid',
    'pending',
    'failed',
    'refunded',
]);
export const TransactionSchema = z.object({
    session_id: z.string(),
    tenant_id: z.string(),
    user_id: z.string().optional(),
    amount_cents: z.number().int().nonnegative(),
    status: TransactionStatusSchema,
    stripe_payment_intent_id: z.string().optional(),
    created_at: z.coerce.date(),
});
//# sourceMappingURL=billing.js.map